export default __webpack_public_path__ + "static/media/svg-defs.f5487078.svg";